import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { Mail } from '../shapes';


const MailSvg = (props) => (
  <g>
    <IconBounds />
    <Mail {...props} />
  </g>
);

MailSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

MailSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default MailSvg;
